import { render, staticRenderFns } from "./DmPreislisten.vue?vue&type=template&id=38fb2228&"
import script from "./DmPreislisten.vue?vue&type=script&lang=js&"
export * from "./DmPreislisten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports